import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from '../../decorators';
import { PostMissingDocsEmail } from 'domain/usecases/vendors/post-missing-docs-email';
import { RemoteSendMissingDocsEmail } from 'data/usecases/remote-send-missing-docs-email';

export const makeRemoteSendMissingDocsEmail = (): PostMissingDocsEmail => {
  return new RemoteSendMissingDocsEmail(
    makeApiUrl('/reports/vendors/email/missingdocs'),
    makeAuthorizeHttpClientDecorator()
  );
};
